import { Init, Shop, ShopApi } from 'microshop-api';
import { config } from './api';

const shopApi = new ShopApi(config);

// The generated Init mapper keeps only the properties it knows, so it drops withdrawalEnabled until the
// client is regenerated. Read it from the raw response of the same request; after `npm run api-local`
// this can go back to shopApi.shopInfo().
export type InitWithWithdrawal = Init & { withdrawalEnabled?: boolean };

const initiate = async (): Promise<InitWithWithdrawal> => {
    const response = await shopApi.shopInfoRaw();
    const raw = await response.raw.clone().json();
    return { ...(await response.value()), withdrawalEnabled: raw?.withdrawalEnabled === true };
};

const shop = {
    initiate,
    load: (): Promise<Shop> => shopApi.shopGet(),
    verify: (): Promise<boolean> => shopApi.shopVerify(),
};

export { shop };
